"use strict";

var config = require("app/util/config/config");
var APICaller = require("./api-caller");

var biAPI = new APICaller(config.app.biURL);

biAPI.fetch = function(url, params, completed, failed) {
  var options = {
    success: function(response) {
      completed(response.body);
    },
    error: function(err) {
      failed();
    }
  };
  this.get(url, params, options);
};

module.exports = biAPI;



// WEBPACK FOOTER //
// ./app/util/api/bi-api.js